import { useConversationById } from '../chat-store/useConversationById';

import { useConversationData } from './useConversationData';
import type { UseConversationProps } from './UseConversationProps';
import type { UseConversationResult } from './UseConversationResult';

export const useChatConversation = ({
	conversationId,
	assistanceServiceParams,
}: Required<Pick<UseConversationProps, 'conversationId'>> &
	Pick<UseConversationProps, 'assistanceServiceParams'>): UseConversationResult => {
	const conversation = useConversationById({ conversationId });

	return useConversationData({
		conversationId,
		conversation,
		assistanceServiceParams,
	});
};
